var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fst-UserEvents"},[_c('div',{staticClass:"admin-content mw-950"},[_c('div',{},[_c('UserEventReportForm',{ref:"form"}),_c('el-button',{staticClass:"mt-3",attrs:{"type":"primary"},on:{"click":_vm.handleDownload}},[_c('i',{staticClass:"fas fa-download mr-1"}),_vm._v(" Download ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }